export default {
    page_title: "Kevi | Files Gallery",
    modal: {
        title: "Files Gallery",
        subtitle: "Select an existing file or upload a new one",
        clear: "Clear",
        upload_button: "Upload",
        filter_all: "All",
        filter_image: "Images",
        filter_video: "Videos",
        filter_audio: "Audio",
        filter_other: "Other",
        loading_files: "Loading files...",
        empty_state: "You do not have any files yet. Upload the first one now!",
        drop_here: "Drop here to upload",
        upload_title: "Drag and drop files here",
        upload_subtitle: "or click to select (max. {0}MB per file)",
        upload_progress: "Upload progress",
        cancel: "Cancel",
        use_file: "Use file",
        icon_pdf: "PDF",
        icon_video: "VID",
        icon_audio: "AUD",
        icon_file: "FILE",
    },
    no_files_text: "You don't have any Files yet,",
    no_files_cta: "create the first one now!",
    delete_confirm: {
        title: "Delete File",
        question: "Are you sure you want to delete the file <strong>{0}</strong>?",
        warning: "If it is being used in any action, the image will not be displayed.",
        irreversible: "This action cannot be undone.",
    },
    search_placeholder: "Filter by File Name",
    upload_area: "Click to upload or drag and drop files here",
    copy_url: "Copy URL",
    delete_button: "Delete",
    no_results_search: "No files found with <strong>{0}</strong>",
    no_results_filter: "No files found with this filter",
    ai: {
        create_title: "Create image with KeviAI",
        edit_title: "Edit image with KeviAI",
        back: "Back",
        edit_prompt_label: "What do you want to change in the image?",
        create_prompt_label: "Describe the image",
        prompt_placeholder: "Example: A cozy coffee shop with soft light, professional photography style",
        improve_prompt: "Improve prompt",
        generate_edit: "Generate edit",
        improved_prompt_label: "Improved prompt (you can edit it)",
        choose_style: "Choose style",
        choose_style_label: "Choose a visual style",
        generate_image: "Generate image",
        generating: "Generating image...",
        adjust: "Adjust",
        save_to_gallery: "Save to gallery",
        preview: "Preview",
        select_file: "Select a file",
        preview_generated_here: "The generated image will appear here",
        edit_with_keviai: "Edit with KeviAI",
        back_to_gallery: "Back to gallery",
        use_image: "Use image",
        image_saved: "Image saved to gallery!",
        error_improve_prompt_unavailable: "Could not improve the prompt.",
        error_improve_prompt: "Error improving the prompt. Please try again.",
        error_generate_image_unavailable: "Could not generate the image.",
        error_generate_image: "Error generating the image. Please try again.",
        error_edit_image_unavailable: "Could not edit the image.",
        error_edit_image: "Error editing the image. Please try again.",
        error_save_image: "Error saving image to gallery.",
        style: {
            realistic_title: "Realistic photography",
            realistic_description: "Natural lighting, sharp details, photographic look.",
            studio_title: "Studio product",
            studio_description: "Clean background, soft shadows, focus on the product.",
            illustration_title: "Illustration",
            illustration_description: "Artistic strokes, illustrated look, balanced colors.",
            watercolor_title: "Watercolor",
            watercolor_description: "Soft textures, brushstrokes, and watercolor tones.",
            three_d_title: "3D",
            three_d_description: "3D render, volume, realistic materials.",
            minimal_title: "Minimalist",
            minimal_description: "Few elements, clean composition, simple colors.",
        },
    },
    filter_label: "File Type",
    filter_options: {
        image: "Image",
        pdf: "PDF",
        video: "Video",
        audio: "Audio",
        other: "Other",
    },
    notifications: {
        url_copied: "URL copied successfully!",
        url_copy_error: "Could not copy the URL.",
        upload_success: "File(s) uploaded successfully!",
        upload_error_title: "Error uploading file(s)!",
        upload_error_message: "Error uploading file(s), please try again later!",
        oversized_files: "Files larger than 20MB:",
        load_error: "Error loading files. Please try again.",
        delete_success: "File deleted successfully!",
        delete_error: "Error deleting file. Please try again.",
    },
};
